import { KeyframeConfig } from "../../../models/animations.model";

export const getStompBaseKeyframe = (
  scaleX: number,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            scaleX: 3 * scaleX,
            scaleY: 3 * scaleY,
          },
          {
            scaleX,
            scaleY,
          },
        ],
      },
    },
  ];
};
